export const enumDictionary = {
  'Status': {
    'EM_ANALISE': 'Em análise',
    'RECUSADA': 'Recusada',
    'ACEITA': 'Aceita',
    'VIGENTE': 'Vigente',
    'CANCELADA': 'Cancelada',
    'CANCELADO': 'Cancelada',
    'PROCESSANDO': 'Processando',
    'PROCESSADO': 'Processado',
    'AGUARDANDO_PROCESSAMENTO': 'Aguardando Processamento',
    'PROCESSADO_ERRO': 'Processado',
    'ERRO': 'Erro',
    'Pendente': 'Pendente',
    'Em Andamento': 'Em andamento',
    'Finalizado': 'Finalizado',
    'Regular': 'Regular',
    'Irregular': 'Irregular',
    'ATIVA': 'Ativa',
    'INATIVA': 'Inativa',
    'ATIVO': 'Ativa',
    'SEM_COBERTURA': 'Sem cobertura',
    '1': 'Novo',
    '2': 'Validando arquivo',
    '3': 'Aguardando processamento',
    '4': 'Em processamento',
    '5': 'Processado',
    '6': 'Preparando download',
    '7': 'Concluído',
    '8': 'Pausado',
    '9': 'Cancelado',
    'Novo': 'Novo',
    'Validando arquivo': 'Validando arquivo',
    'Aguardando processamento': 'Aguardando processamento',
    'Em processamento': 'Em processamento',
    'Processado': 'Processado',
    'Preparando download': 'Preparando download',
    'Concluído': 'Concluído',
    'Pausado': 'Pausado',
    'Cancelado': 'Cancelada',
  },
  'TipoCadastro': {
    'API_INDIVIDUAL': 'Cadastro Individual por API',
    'API_LOTE': 'Cadastro em Lote por API',
    'TELA_INDIVIDUAL': 'Cadastro em tela individual',
    'TELA_LOTE': 'Cadastro em lote por tela'
  },
  'Grupo': {
    'VI': 'Vida Individual',
    'VG': 'Vida Grupo'
  },
  'AtivoStatus': {
    'ATIVO': 'Ativo',
    'INATIVO': 'Inativo'
  },
  'TipoConsultaAssistencia': {
    'cpfCnpj': 'CPF/CNPJ',
    'placaChassi': 'Placa/Chassi',
    'telefone': 'Telefone Solicitante'
  },
  'CodigoCoberturaAuto': {
    '1': 'Compreensiva',
    '2': 'RCF',
    '3': 'Incêndio',
    '4': 'Incêndio e Roubo/Furto',
    '5': 'Roubo /Furto',
    '6': 'Perda Total',
    '7': 'Perda Parcial',
  },
  'CategoriaAuto': {
    '1': 'Passeio Nacional',
    '2': 'Passeio Importado',
    '3': 'SUV Nacional',
    '4': 'SUV Importada',
    '5': 'Pick-up Leve Nacional',
    '6': 'Pick-up Leve Importado',
    '7': 'Pick-up Pesada Nacional',
    '8': 'Pick-up Pesada Importado',
    '9': 'Motocicleta Nacional',
    '10': 'Motocicleta Importada',
    '11': 'Caminhão Leve Nacional',
    '12': 'Caminhão Leve Importado',
    '13': 'Caminhão Pesado Nacional',
    '14': 'Caminhão Pesado Importado',
    '15': 'Ônibus Nacional',
    '16': 'Ônibus Importado',
    '17': 'Caminhão Extrapesado Nacional',
    '18': 'Caminhão Extrapesado Importado ',
    '19': 'Semirreboque Nacional',
    '20': 'Semirreboque Importado',
    '21': 'Rebocador Nacional',
    '22': 'Rebocador Importado',
  },
  'TipoVigenciaAuto': {
    '1': 'Anual',
    '2': 'Plurianual',
    '3': 'Mensal',
    '4': 'Diária',
  },
  'TipoVigenciaDescricaoAuto': {
    'ANUAL': 'Anual',
    'PLURIANUAL': 'Plurianual',
    'MENSAL': 'Mensal',
    'DIARIA': 'Diária',
  },
  'TipoOperacaoAuto': {
    '1': 'Seguro Novo',
    '2': 'Renovação Própria',
    '3': 'Renovação Congênere',
  },
  'TipoOperacaoDescriptionAuto': {
    'NOVO_SEGURO': 'Seguro Novo',
    'RENOVACAO_PROPRIA': 'Renovação Própria',
    'RENOVACAO_CONGENERE': 'Renovação Congênere',
  },
  'StatusAuto': {
    '1': 'Vigente',
    '2': 'Sem cobertura',
    '3': 'Cancelada',
  },
  'SegmentoAuto': {
    '1': 'Individual',
    '2': 'Frota',
  },
  'SegmentoDescricaoAuto': {
    'INDIVIDUAL': 'Individual',
    'FROTA': 'Frota',
  },
  'EndossoAutoDescription': {
    'ENDOSSO_CANCELAMENTO': 'Endosso de Cancelamento',
    'ENDOSSO_EXCLUSAO_ITEM': 'Endosso de Exclusão de Item',
    'ENDOSSO_INCLUSAO_ITEM': 'Endosso de Inclusão de Item',
    'ENDOSSO_ALTERACAO_TECNICA': 'Endosso de Alteração Técnica',
    'ENDOSSO_SUBSTITUICAO': 'Endosso de Substituição de Risco'
  },
  'TipoDivergenciaAuto': {
    'PLACA_CHASSI': 'Placa e chassi não correspondentes',
    'CEP': 'CEP inexistente',
    'CPF': 'CPF/CNPJ e nome/razão social não correspondentes',
  },
  'IdTipoDivergenciaAuto': {
    1: 'CEP Inexistente',
    2: 'Placa e chassi não correspondentes',
    3: 'CPF/CNPJ e nome/razão social não correspondentes',
  }

};
